
import {Fetch} from "../../utils/storage"
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"


export default {
name: 'Order-detail',
components: {
XInput,
XButton,
Group,
},
filters: {
/**
* @return {string}
*/
meetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
},
},
data () {
return {
ApplyReq:{},
Meeting:{},
SubMeeting:{},
Order:{},
OrderInfo:{},
HotelOrder:{},
MeetingID: 0,
OrderID:0,
UserID:0,
HasHotel: true,
ChosenHotel:[],
HotelForm:{
CheckInAt:[],
CheckOutAt:[]
},
}
},
created () {
this.OrderID = this.$route.params["orderID"]
if (!this.OrderID) this.$router.go(-1)
this.OrderID = parseInt(this.OrderID)
this.UserID = Fetch("ID")
this.fetchOrderDetail()
},
methods: {
ParseTime,
async fetchOrderDetail() {
let res = await Api('GetOrderList',{
Data:{
ID:this.OrderID,
},
Preloads:[
{Column:'OrderInfo'},
]
})
if (res.data.List && res.data.List.length === 1) {
this.Order = res.data.List[0]
this.OrderInfo = this.Order.OrderInfo
this.ApplyReq = {
InvoiceTitle: this.OrderInfo.InvoiceTitle,
InvoiceNum: this.OrderInfo.InvoiceNum,
Email: this.OrderInfo.Email,
OrderIDs: [this.Order.ID]
}
} else {
this.$vux.toast.show({
text:'获取订单信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
handleSubmit() {

let _this = this
if (!this.Order.Fee || this.Order.Fee == 0) {
_this.$vux.toast.show({
text: '免费会议，不可开发票！',
type: 'text',
width: '3.5rem'
})
return
}
if (
!this.ApplyReq.InvoiceNum ||
this.ApplyReq.InvoiceNum.length < 15) {
this.$vux.toast.show({
text: '发票税号不可为空，且不得少于15位！',
type: 'text',
width:'3rem'
})
return
}
if (
!this.ApplyReq.InvoiceTitle) {
this.$vux.toast.show({
text: '发票税号不可为空',
type: 'text',
width:'3rem'
})
return
}

if (!this.ApplyReq.Email) {
this.$vux.toast.show({
text: '发票接受邮箱不可为空！',
type: 'text',
width:'3rem'
})
return
}
if (!this.$refs.emailAddInput.valid) {
this.$vux.toast.show({
text: '发票接受邮箱格式错误！',
type: 'text',
width:'3rem'
})
return
}
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">请确认发票接收邮箱、发票信息正确，如填写错误，将影响发票开取！！！</span>`,
confirmText:"我已确认",
cancelText:"取消",

async onConfirm(){
try {
let res = await Api('InvoiceApplyYongyou', _this.ApplyReq)
if (res.data.Message != 'success') {
throw Error(res.data.Message)
}
_this.$vux.toast.show({
text: '发起开票成功，发票将会发送至您邮箱！',
type: 'text',
width: '3rem'
})
_this.$router.go(-1)
} catch (err) {
_this.$vux.toast.show({
text: `发起开票请求失败：${err.message}`,
type: 'text',
width: '3rem'
})

}
}
})

},
},
}
